import { defineMessages } from 'react-intl';


export default defineMessages({
  instructionHeaderTitle: {
    id: 'app.containers.Photosphere.InstructionsHeaders.Title',
    defaultMessage: 'Envio de fotos 360',
  },
  instructionHeaderSubtitle: {
    id: 'app.containers.Photosphere.InstructionsHeaders.Subitle',
    defaultMessage: 'Selecione as mídias feitas nessa sessão',
  },
  instructionHeaderCardTitle: {
    id: 'app.containers.Photosphere.InstructionsHeaders.CardTitle',
    defaultMessage: 'Requisitos para enviar suas fotos',
  },
  instructionHeaderCardDescription: {
    id: 'app.containers.Photosphere.InstructionsHeaders.CardDescription',
    defaultMessage: 'Envie as fotos 360 na ordem do checklist: ',
  },
  instructionHeaderCardDescriptionItems: {
    id: 'app.containers.Photosphere.InstructionsHeaders.CardDescriptionItems',
    defaultMessage: 'Sala / Banheiro / Quarto / Cozinha / Área de serviço / Condomínio',
  },
  secondInstructionHeaderCardDescription: {
    id: 'app.containers.Photosphere.InstructionsHeaders.SecondCardDescription',
    defaultMessage: 'As fotos 360° devem ter menos que ',
  },
  secondInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photosphere.InstructionsHeaders.SecondCardDescriptionItem',
    defaultMessage: '10Mb',
  },
  thirdInstructionHeaderCardDescription: {
    id: 'app.containers.Photosphere.InstructionsHeaders.ThirdCardDescription',
    defaultMessage: 'Formato ',
  },
  thirdInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photosphere.InstructionsHeaders.ThirdCardDescriptionItems',
    defaultMessage: 'JPEG',
  },
  fourthInstructionHeaderCardDescription: {
    id: 'app.containers.Photosphere.InstructionsHeaders.FourthCardDescription',
    defaultMessage: 'Sugerimos que use o tamanho ',
  },
  fourthInstructionHeaderCardDescriptionBoldItem: {
    id: 'app.containers.Photosphere.InstructionsHeaders.FourthCardDescriptionItems',
    defaultMessage: '2400x1600',
  },
});
